/** @format */

import { isEqual } from 'lodash';
import { DEFAULT_FILTERS_INITIAL_STATE, DEFAULT_FILTERS_INITIAL_STATE_FOR_POI } from '../../@ducks/filters/constants';
import { useAppSelector } from '../../redux/hooks';

export const checkDefaultFiltersPoi = (exclude?: 'date' | 'order' | 'price' | 'filter' | 'typeRoom' | 'allFilters') => {
  const searchFilters = useAppSelector(store => store.filters);
  const cityName = searchFilters.cityName || '';
  let defaultInitialFilters = {};
  let defaultFilters = {};

  const { area, ...withouthPoi } = searchFilters;

  const { checkInDate, ...whithoutDate } = withouthPoi;
  const { checkInDate: checkInDateStore, ...filtersWhithoutDate } = DEFAULT_FILTERS_INITIAL_STATE_FOR_POI(cityName);

  const { singleRoom, entireStudio, sharedApartment, colivingBuilding, ...whithoutTypeRoom } = withouthPoi;
  const {
    singleRoom: singleRoomDefault,
    entireStudio: entiresStudiDefault,
    sharedApartment: sharedApartamentDefault,
    colivingBuilding: colivingBuildingDefault,
    ...filtersWhithoutTypeRoom
  } = DEFAULT_FILTERS_INITIAL_STATE_FOR_POI(cityName);

  const { orderBy, ...whithoutOrder } = withouthPoi;
  const { orderBy: orderByStore, ...filtersWhithoutOrder } = DEFAULT_FILTERS_INITIAL_STATE_FOR_POI(cityName);

  const { monthlyPrice, ...filtersWithoutPrice } = withouthPoi;
  const { monthlyPrice: priceStore, ...withoutPrice } = DEFAULT_FILTERS_INITIAL_STATE_FOR_POI(cityName);

  const {
    concierge,
    elevator,
    privateBathroom,
    balcony,
    bikeParking,
    topFloor,
    lowerFloor,
    parquet,
    clothesDryer,
    airConditioning,
    internalSide,
    gym,
    inSuiteLaundry,
    ...withoutFilter
  } = withouthPoi;
  const {
    inSuiteLaundry: storeLaundry,
    gym: gymStore,
    internalSide: internalStore,
    concierge: conciergeStore,
    elevator: elevatorStore,
    privateBathroom: bathStore,
    balcony: balconyStore,
    bikeParking: bikeStore,
    topFloor: floorStore,
    lowerFloor: lowerFloorStore,
    parquet: parwuetStore,
    clothesDryer: clothesStore,
    airConditioning: airStore,
    ...FilterswithoutFilters
  } = DEFAULT_FILTERS_INITIAL_STATE_FOR_POI(cityName);

  const isDynamicSearchByPoi = Object.entries(area).length > 1;

  switch (exclude) {
    case 'date':
      defaultFilters = whithoutDate;
      defaultInitialFilters = filtersWhithoutDate;
      break;
    case 'order':
      defaultFilters = whithoutOrder;
      defaultInitialFilters = filtersWhithoutOrder;
      break;
    case 'typeRoom':
      defaultFilters = whithoutTypeRoom;
      defaultInitialFilters = filtersWhithoutTypeRoom;
      break;
    case 'price':
      defaultFilters = withoutPrice;
      defaultInitialFilters = filtersWithoutPrice;
      break;
    case 'filter':
      defaultFilters = withoutFilter;
      defaultInitialFilters = FilterswithoutFilters;
      break;
    case 'allFilters':
      defaultFilters = searchFilters;
      defaultInitialFilters = DEFAULT_FILTERS_INITIAL_STATE(cityName);
      break;

    default:
      defaultFilters = withouthPoi;
      defaultInitialFilters = DEFAULT_FILTERS_INITIAL_STATE_FOR_POI(cityName);
  }

  return {
    isDefaultFilters: isEqual(defaultFilters, defaultInitialFilters),
    isDynamicSearchByPoi,
  };
};
